import TablePaginadaBasic from "@/Components/Base/Table/TablePaginadaBasic";
import OpceosTitulo from "@/Components/Populados/Financeiro/Titulo/OpceosTitulo";
import ResponsiveAntdTable from "@/Components/ResponsiveAntdTable";
import Titulo from "@/Models/Financeiro/Titulo/Titulo";
import BloqueioItem from "@/Models/Pessoa/Bloqueio/BloqueioItem";
import { EnumBloqueioTipo } from "@/Models/Pessoa/Bloqueio/BloqueioTipo";
import { useBloqueioItemListarPorBloqueio } from "@/Services/Pessoa/Bloqueio/BloqueioItemService";
import { CheckCircleOutlined, SettingOutlined } from "@ant-design/icons";
import { Row } from "antd";
import useToken from "antd/lib/theme/useToken";

export interface IBloqueioItemTableProps {
    codBloqueio : number;
    codBloqueioTipo : keyof typeof EnumBloqueioTipo;
}
export default function BloqueioItemTable({
    codBloqueio,
    codBloqueioTipo
}:IBloqueioItemTableProps) {
    const tema = useToken();

    const {
        data,
        isLoading,
        isFetching,
        refetch
    } = useBloqueioItemListarPorBloqueio({
        codBloqueio,
        codBloqueioTipo,
    });

    return <ResponsiveAntdTable<BloqueioItem> 
        dataSource={data ?? []}
        bordered
        locale={{ emptyText: 'Nenhuma pendência foi encontrada.' }}
        disableResponsiveness={true}
        tableLayout="auto"
        size="small"
        scroll={{
            x: true,
        }}
        pagination={false}
        showHeader={true}
        minColWidthIfResponsivenessDisabled={"120px"}
        loading={isLoading || isFetching}
        rowKey={(k) => k.codigo}
        columns={[
            {
                key : "Criado",
                title : "Criado em",
                dataIndex : "dataCriacao",
                render(value:Date, _, __) {
                    return value.toLocaleDateString();
                },
            },
            {
                key : "motivo",
                title : "Motivo",
                dataIndex : "motivo",
                ellipsis : {
                    showTitle : true
                }
            },
            {
                key : "parcela",
                title : "Desc. Parcela",
                dataIndex : ["parcela", "nomeExibicao"],
                ellipsis : {
                    showTitle : true
                },
            },
            {
                key : "dataResolucao",
                title : "Resolvido em",
                dataIndex : "dataResolucao",
                render(value, _, __) {
                    return value?.toLocaleDateString?.() ?? ' - ';
                },
            },
            {
                key : "acoes",
                title : "Parcela",
                dataIndex : ["codParcela"],
                minWidth : "50px",
                fixed : "right",
                ellipsis : {
                    showTitle : true
                },
                render(value, record, index) {
                    return <Row justify={"center"}>
                        {record.resolvido ? <CheckCircleOutlined style={{ color : "var(--ant-color-success)" }} title="Item Resolvido" /> : <OpceosTitulo
                            isDesativar={true}
                            isAtivar={true}
                            isPagar={true}
                            isVisualizar={true}
                            onSucess={() => refetch()}
                            titulo={(record as any).parcela as Titulo}
                            children={<SettingOutlined />}
                        />}
                    </Row>;
                },
            }
        ]}
    />;
}